module.exports = __webpack_public_path__ + "img/manual-grn-00-print-batch.d99c0c76.png";